import Logger, { ILogger } from 'js-logger';

// Extend the logger interface to include custom methods.
interface ExtendedLogger extends ILogger {
    errorAndThrow(message: string): never;
}

const baseLogger = Logger.get('ladon-ts');

// Create an extended logger with custom methods.
const logger: ExtendedLogger = Object.assign(baseLogger, {
    errorAndThrow(message: string): never {
        baseLogger.error(message);
        throw new Error(message);
    },
});

// Create a handler to send logs to the console.
const consoleLogHandler = Logger.createDefaultHandler({
    /**
     * Formatter for console logs.
     *
     * @param msg - Log message.
     * @param context - Log context.
     */
    formatter: (msg, context) => {
        msg.unshift(context.name);
    },
});

Logger.setHandler(consoleLogHandler);

export { Logger, logger };
